export default "__VITE_ASSET__91WMRKfb__"